import {Fragment} from 'react';
import cx from 'classnames';

import {Text} from '#component/base';
import {sprinkles} from '#style/sprinkles';

import {ProgressTrackerProps} from './ProgressTracker.types';

import * as css from './ProgressTracker.css';

export const ProgressTracker = ({
  className,
  items = [],
  currentItemIndex: _currentItemIndex = 0,
  currentItemStatus,
}: ProgressTrackerProps) => {
  const currentItemIndex = Math.min(Math.max(_currentItemIndex || 0, -1), items.length - 1);

  return (
    <div className={cx(sprinkles({flex: 'flex', dir: 'col'}), className)}>
      {items.map(({title, subtitle}, index) => {
        let status: css.ItemStatus = 'incomplete';
        let nextStatus: css.ItemStatus = 'incomplete';

        if (currentItemIndex > index) {
          status = 'completed';
        } else if (currentItemIndex === index) {
          status = currentItemStatus === 'completed' ? 'completed' : 'inProgress';
        }

        if (currentItemIndex > index + 1) {
          nextStatus = 'completed';
        } else if (currentItemIndex === index + 1) {
          nextStatus = currentItemStatus === 'completed' ? 'completed' : 'inProgress';
        }

        return (
          <Fragment key={index}>
            <div className={sprinkles({flex: 'flex', dir: 'row', grow: 1, gap: 24})}>
              <div className={css.itemTrack}>
                <Text
                  className={css.itemMarker({
                    isFirst: index <= 0,
                    isLast: index >= items.length - 1,
                    status,
                  })}
                />
              </div>

              <Text
                as="div"
                color={status !== 'incomplete' ? 'doveGray' : 'dustyGray'}
                fontWeight="semiBold">
                {title}
              </Text>
            </div>

            {subtitle && (
              <div className={sprinkles({flex: 'flex', dir: 'row', grow: 1, gap: 24})}>
                <div className={css.itemTrack}>
                  <Text className={css.itemLine({isActive: status !== 'incomplete'})} />
                  <div className={css.itemLine({isActive: status !== 'incomplete'})} />
                </div>

                <Text as="div" color="dustyGray" variant="caption">
                  {subtitle}
                </Text>
              </div>
            )}

            {index < items.length - 1 && (
              <div className={sprinkles({flex: 'flex', dir: 'row', grow: 1, gap: 24})}>
                <div className={css.itemTrack}>
                  <div
                    className={css.itemLine({
                      isActive: (subtitle ? nextStatus : status) !== 'incomplete',
                    })}
                  />
                  <div className={css.itemLine({isActive: nextStatus !== 'incomplete'})} />
                </div>

                <div className={css.itemGap} />
              </div>
            )}
          </Fragment>
        );
      })}
    </div>
  );
};
